import request from '@/utils/request'


// 获取角色列表
export function getRoleList(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/role/list',
    method: 'post',
    data
  })
}


// 获取角色详情
export const getRoleById = (id) => {
  return request({
    url: `/api/role/${id}`,
    method: 'get'
  })
}

// 新增角色
export const addRole = (data) => {
  return request({
    url: '/api/role/add',
    method: 'post',
    data
  })
}

// 更新角色
export const updateRole = (data) => {
  return request({
    url: '/api/role/update',
    method: 'put',
    data
  })
}

// 删除角色
export const deleteRole = (id) => {
  return request({
    url: `/api/role/delete/${id}`,
    method: 'delete'
  })
}


/**
 * 获取角色菜单权限
 */
export const getRoleMenus = (roleId) => {
  const lang = localStorage.getItem('lang') || 'zh-CN';
  return request({
    url: `/api/role/menus/${roleId}`,
    method: 'get',
    params: { lang }
  });
};


/**
 * 更新角色菜单权限
 */
export const updateRoleMenus = (data) => {
  const lang = localStorage.getItem('lang') || 'zh-CN';
  return request({
    url: '/api/role/menus',
    method: 'put',
    data: { ...data, lang }
  });
};


// 获取所有菜单
// 获取所有菜单
export const getAllMenus = () => {
  const lang = localStorage.getItem('lang') || 'zh-CN';
  return request({
    url: '/api/menu/list',
    method: 'get',
    params: { lang: lang }  // 使用 params 传递查询参数
  });
};


/**
 * 获取用户权限标识列表（用于按钮级权限控制）
 */
export function getUserPermissions(lang) {
  return request({
    url: '/api/menu/user-permissions',
    method: 'get',
    params: { lang }
  })
}

/**
 * 获取用户完整权限信息（菜单 + 权限标识 + 用户信息）
 */
export function getUserFullPermissions(lang) {
  return request({
    url: '/api/menu/user-full-permissions',
    method: 'get',
    params: { lang }
  })
}